import "./Home.module.css";
import EnterpriseHeader from "@/reusable_sections/Header";
import GovernedAiAnswersFromApprovedContentOnly from "./sections/GovernedAiAnswersFromApprovedContentOnly";
import VerifiedTrustSignals from "./sections/VerifiedTrustSignals";
import DraftReviewApproved from "./sections/DraftReviewApproved";
import PredictableAiCostsWithByoKey from "./sections/PredictableAiCostsWithByoKey";
import WhyEloragVsGenericAiTools from "./sections/WhyEloragVsGenericAiTools";
import SeeHowEloragWorks from "./sections/SeeHowEloragWorks";
import SectorSolutions from "./sections/SectorSolutions";
import Faq from "./sections/Faq";
import CallToAction from "./sections/CallToAction";
import NetworkFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <EnterpriseHeader />
      <GovernedAiAnswersFromApprovedContentOnly />
      <VerifiedTrustSignals />
      <DraftReviewApproved />
      <PredictableAiCostsWithByoKey />
      <WhyEloragVsGenericAiTools />
      <SeeHowEloragWorks />
      <SectorSolutions />
      <Faq />
      <CallToAction />
      <NetworkFooter />
    </div>;
}